"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleRadio = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const SimpleRadio = ({ value, onChange, group, checked, error, id, disabled }) => {
    return (react_1.default.createElement("input", { type: "radio", value: value, name: group, checked: checked, id: id, disabled: disabled, onChange: onChange && ((e) => onChange(value, e)), className: (0, classnames_1.default)('relative h-5 w-5 appearance-none rounded-full border-2  before:bg-white checked:border-white checked:before:absolute checked:before:top-1/2 checked:before:left-1/2 checked:before:h-2 checked:before:w-2 checked:before:-translate-x-1/2 checked:before:-translate-y-1/2 checked:before:rounded-full focus:ring focus:ring-blue-5', disabled
            ? 'bg-grey-1 checked:bg-blue-5/40'
            : error
                ? 'border-red-5 bg-white checked:bg-red-5'
                : 'border-black bg-white checked:bg-blue-5') }));
};
exports.SimpleRadio = SimpleRadio;
